export function requireLogin(user, navigate, toast, message) {
  if (user) return true;
  const text =
    message ||
    "Please sign in to use this feature.";
  if (typeof toast === "function") {
    toast(text, "info");
  } else {
    alert(text);
  }
  if (typeof navigate === "function") {
    navigate("/login");
  }
  return false;
}
